import { SxProps } from '@mui/material/styles';

import HookFormTextField from 'reservations/form/components/HookFormTextField';

type EmailFormFieldProps = {
  handleOnBlur?: (value: string) => void;
  autoFocus?: boolean;
  sxOverride?: SxProps;
  labelSxOverride?: SxProps;
  errorColorOverride?: SxProps;
};

function EmailFormField({
  handleOnBlur,
  autoFocus = false,
  sxOverride = {},
  labelSxOverride = {},
  errorColorOverride = {}
}: EmailFormFieldProps) {
  return (
    <HookFormTextField
      name="email"
      label="Email"
      handleOnBlur={handleOnBlur}
      required
      autoFocus={autoFocus}
      sxOverride={sxOverride}
      labelSxOverride={labelSxOverride}
      errorColorOverride={errorColorOverride}
    />
  );
}

export default EmailFormField;
